<template>
  <v-card>
    <v-card-title>Модель события</v-card-title>
    <v-card-text>
      <template v-if="single.resource">
        Для данного события используется 3D-модель. Вы можете использовать редактор,
        чтобы изменить положение/размеры, откорректировать размещение модели на карте.
        Чтобы заменить модель, следует удалить текущую.
      </template>
      <template v-else>
        Загрузите модель для события.<br>
        Для загрузки допускаются архивы с расширениями <b>*.tar.gz, *.gzip, *.tar, *.glb</b>.<br>
        Архив должен папку с моделью и её текстурами/данными. Имя архива, вложенной папки
        и модели <b>ОБЯЗАТЕЛЬНО</b> должны быть идентичными.

        <v-file-input
          v-model="selectedModelFile"
          v-permission="['layer-data-edit']"
          label="Выберите архив"
          accept=".tar.gz,.gzip,.tar,.glb"
          :success="modelSuccessfullyUploaded"
          :success-messages="modelSuccessfullyUploaded ? ['Модель успешно загружена'] : []"
          @change="onModelUpload"
        />

        <v-btn
          v-permission="['layer-data-edit']"
          :disabled="!modelSuccessfullyUploaded"
          color="success"
          class="mt-4"
          width="100%"
          @click="onResourceAttach"
        >
          Применить модель к событию
        </v-btn>
      </template>
    </v-card-text>
    <v-card-actions v-permission="['layer-data-edit']">
      <template v-if="single.resource">
        <v-btn
          color="success"
          text
          @click="$dialog.show('map-model-editor-dialog')"
        >
          Открыть редактор
        </v-btn>
        <div class="flex-grow-1" />
        <v-btn color="error" @click="onDetachResource">Удалить модель</v-btn>
      </template>
    </v-card-actions>
    <map-model-editor-dialog
      v-if="resourceModel.id"
      v-model="resourceModel.settings"
      :model="resourceModel.file"
      @save="onModelSettingsSave"
    />
  </v-card>
</template>

<script>
import { mapActions } from 'vuex';
import { uploadFile } from '@/utils/requests/upload';
import MapModelEditorDialog from '@/components/dialogs/map/editor/MapModelEditorDialog.vue';

const createDefaultResourceModel = () => ({
  id: null,
  file: null,
  settings: {},
});

export default {
  name: 'layers-item-view-model-tab',
  components: {
    MapModelEditorDialog,
  },
  props: {
    single: Object,
  },
  data: () => ({
    selectedModelFile: null,
    modelSuccessfullyUploaded: false,
    resourceModel: createDefaultResourceModel(),
  }),
  created() {
    this.updateResourceModelData();
  },
  methods: {

    ...mapActions(['showNotify']),
    ...mapActions('layer-objects', [
      'attachResource',
      'detachResource',
      'storeModelSettings',
      'getItem',
    ]),

    async onModelUpload(file) {
      try {
        this.$emit('changeLayerLoadingState', true);
        const response = await uploadFile(file);

        this.resourceModel.path = response.path;
        this.resourceModel.id = response.id;

        this.modelSuccessfullyUploaded = true;
      } finally {
        this.$emit('changeLayerLoadingState', false);
      }
    },

    async onResourceAttach() {
      const params = {
        fileId: this.resourceModel.id,
        settings: JSON.stringify({}),
      };

      try {
        this.$emit('changeLayerLoadingState', true);
        await this.attachResource({ layerId: this.single.id, params });
        await this.getItem(this.single.id);
        this.updateResourceModelData();
      } finally {
        this.$emit('changeLayerLoadingState', false);
      }
    },

    async onDetachResource() {
      try {
        this.$emit('changeLayerLoadingState', true);
        await this.detachResource(this.single.id);
        this.updateResourceModelData();
        this.showNotify({ message: 'Модель откреплена от события' });
      } catch (e) {
        this.showNotify({ type: 'error', message: 'Что-то пошло не так' });
        throw e;
      } finally {
        this.$emit('changeLayerLoadingState', false);
      }
    },

    updateResourceModelData() {
      this.resourceModel = {
        ...this.resourceModel,
        ...this.single.resource,
      };

      this.selectedModelFile = null;
      this.modelSuccessfullyUploaded = false;
    },

    async onModelSettingsSave(data) {
      try {
        await this.storeModelSettings({
          modelId: this.resourceModel.id,
          settings: JSON.stringify(data),
        });
        this.showNotify({ message: 'Модель успешно обновлена' });
        this.$dialog.hide('map-model-editor-dialog');
      } catch (e) {
        this.showNotify({ type: 'error', message: 'Что-то пошло не так' });
        throw e;
      }
    },
  },
};
</script>

<style scoped>

</style>
